import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "message-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "q-mb-sm"
}
const _hoisted_3 = { class: "message h-radius" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bot_avatar = _resolveComponent("bot-avatar")!
  const _component_message_tail = _resolveComponent("message-tail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMediaVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isMediaComponent.component), {
            src: _ctx.isMediaComponent.src,
            "file-name": _ctx.message.file_name,
            "human-size": _ctx.message.file_size_human,
            hosting: _ctx.isMediaComponent.hosting
          }, null, 8, ["src", "file-name", "human-size", "hosting"])),
          (_ctx.isShowMessageTail && !_ctx.messageTextIsNotEmpty)
            ? (_openBlock(), _createBlock(_component_message_tail, {
                key: 0,
                class: "message-animation"
              }, {
                default: _withCtx(() => [
                  (_ctx.isPhoneSize)
                    ? (_openBlock(), _createBlock(_component_bot_avatar, {
                        key: 0,
                        avatar: _ctx.avatar
                      }, null, 8, ["avatar"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.messageTextIsNotEmpty || _ctx.message.type === 'action_typing')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "text-content message-animation",
          style: _normalizeStyle({ animation: _ctx.message.order === 1 ? 'none' : '' })
        }, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true),
            (_ctx.isInsideMedia)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isMediaComponent.component), {
                  key: 0,
                  src: _ctx.isMediaComponent.src,
                  "file-name": _ctx.message.file_name,
                  "human-size": _ctx.message.file_size_human,
                  hosting: _ctx.isMediaComponent.hosting,
                  class: "inside-media"
                }, null, 8, ["src", "file-name", "human-size", "hosting"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isShowMessageTail)
            ? (_openBlock(), _createBlock(_component_message_tail, {
                key: 0,
                class: "message-animation"
              }, {
                default: _withCtx(() => [
                  (_ctx.isPhoneSize)
                    ? (_openBlock(), _createBlock(_component_bot_avatar, {
                        key: 0,
                        avatar: _ctx.avatar
                      }, null, 8, ["avatar"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}